import moment from "moment";
import {
   HourlyRequestToBookStatus,
   ReservationRequestDetailsModel,
} from "Services/API/API";
import { formatCalendarDateTime } from "Utils/datetime";

export const getExpiredHours = (expiredDate: moment.Moment | string) => {
   const duration = moment.duration(moment(expiredDate).diff(moment()));
   return Math.floor(duration.asHours());
};

export const getPendingStatus = (
   expiredHours: number,
   isMobile = false
) => {
   if (expiredHours < 0) {
      return undefined;
   } else if (expiredHours <= 1) {
      return isMobile
         ? "This request expires in 1 hours"
         : "This request will expire in 1 hour";
   } else if (expiredHours <= 24) {
      return isMobile
         ? `This request expires in ${expiredHours} hours`
         : `This request will expire in ${expiredHours} hours`;
   } else {
      return isMobile
         ? "Respond within 1 business day"
         : "This request must be responded to within 1 business day";
   }
};

export const getAdminStatus = (
   request: ReservationRequestDetailsModel
) => {
   if (request.status == HourlyRequestToBookStatus.Pending) {
      const expiredHours = request.expirationTimeUTC ? getExpiredHours(moment(request.expirationTimeUTC)) : 24;
      return getPendingStatus(expiredHours);
   }
   else
      return getStatus(request);
}

export const getOwnerStatus = (
   request: ReservationRequestDetailsModel
) => {
   if (request.status == HourlyRequestToBookStatus.Paused) {
      return "This request is pending";
   } else {
      return getStatus(request);
   }
}

export const getStatus = (
   request: ReservationRequestDetailsModel
) => {
   const responseTimeFormatted = formatCalendarDateTime(request.responseTime);
   switch (request.status) {
      case HourlyRequestToBookStatus.Pending:
         return "This request is pending";
      case HourlyRequestToBookStatus.Approved:
         return `Approved by ${request.responder} on ${responseTimeFormatted}`;
      case HourlyRequestToBookStatus.Paused:
         return "This request is paused. It will not expire"
      case HourlyRequestToBookStatus.CancelledByHost:
      case HourlyRequestToBookStatus.CancelledByGuest:
      case HourlyRequestToBookStatus.CancelledNoResponse:
         return `Declined by ${request.responder} on ${responseTimeFormatted}`;
      default:
         return "";
   }
}